import React from 'react';
import { Popover } from 'antd';
import { COMPETENCY_BY_ID } from '@evaltick/shared';
import { BuilderChip } from '@/components/BuilderChip';
import { competencyChipColor } from '@/utils/builderChipColors';
import styles from './CompetencyChips.module.scss';

const DEFAULT_MAX_VISIBLE = 5;

const competencyName = (id: string) => COMPETENCY_BY_ID[id]?.name ?? id;

interface CompetencyChipsProps {
  competencyIds: string[];
  maxVisible?: number;
}

export const CompetencyChips: React.FC<CompetencyChipsProps> = ({
  competencyIds,
  maxVisible = DEFAULT_MAX_VISIBLE,
}) => {
  const visible = competencyIds.slice(0, maxVisible);
  const hidden = competencyIds.slice(maxVisible);

  return (
    <div className={styles.list}>
      {visible.map((id) => (
        <BuilderChip key={id} tint={competencyChipColor(id)} title={competencyName(id)}>
          {competencyName(id)}
        </BuilderChip>
      ))}

      {hidden.length > 0 && (
        <Popover
          trigger="click"
          placement="bottomRight"
          align={{ overflow: { shiftX: true, adjustY: true } }}
          classNames={{ root: styles.popover }}
          content={
            <div className={styles.overflowList}>
              {hidden.map((id) => (
                <BuilderChip key={id} tint={competencyChipColor(id)} title={competencyName(id)}>
                  {competencyName(id)}
                </BuilderChip>
              ))}
            </div>
          }
        >
          <button
            type="button"
            className={styles.more}
            aria-label={`Show ${hidden.length} more ${hidden.length === 1 ? 'competency' : 'competencies'}`}
          >
            +{hidden.length}
          </button>
        </Popover>
      )}
    </div>
  );
};

export default CompetencyChips;
